import axios from 'axios';

import { NOMINATIM_URL } from '@/slw/shared/consts/common.const';

import { DealerPartner, NominatimResponse, NominatimSearchParams } from './dealer-partner.type';

export const submitDealerPartner = async (data: DealerPartner) => {
  return await apiClient().post('/ecom-users/become-dealer', data);
};

export const searchLocation = async (params: NominatimSearchParams) => {
  try {
    const response = await axios.get<NominatimResponse[]>(`${NOMINATIM_URL}/search`, {
      params: {
        ...params,
        format: params.format || 'json',
      },
    });

    return response.data?.length ? response.data[0] : ({} as NominatimResponse);
  } catch (error) {
    throw error;
  }
};
